import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../redux/redux.model';
import { useDisclosure } from '../../../hooks/useDisclosure';
import { MethodologyCluster } from '../../../redux/methodologyCluster/models';
import actions from '../../../redux/methodologyCluster/actions';
import { ClusterEventType } from '../../../components/clusterTag/clusterModal.models';
import { handleClusterName, useClusterSegment } from '../../../components/clusterTag/useCluster';

const { addMethodologyCluster, updateMethodologyCluster, removeMethodologyCluster } = actions;

export const useCharacteristicClustering = () => {
  const dispatch = useDispatch();
  const isCharacteristicClusteringEnabled = useSelector(
    (state: AppState) => state.App.systemFlags.P40_50021_ENABLE_CHARACTERISTIC_CLUSTERING
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { handleClusterTracking } = useClusterSegment();

  const handleCreateCluster = (newCluster: MethodologyCluster) => {
    dispatch(addMethodologyCluster(newCluster));
    handleClusterTracking(ClusterEventType.Created, {
      clusterNames: [handleClusterName(newCluster.name)],
      numberOfClusters: 1,
      numberOfComponents: newCluster.components_ids?.length ?? 0
    });
  };

  const handleEditCluster = (updatedCluster: MethodologyCluster) => {
    dispatch(updateMethodologyCluster(updatedCluster));
    handleClusterTracking(ClusterEventType.Edited, {
      clusterNames: [handleClusterName(updatedCluster.name)],
      numberOfClusters: 1,
      numberOfComponents: updatedCluster.components_ids?.length ?? 0
    });
  };

  const handleDeleteCluster = (clusterId: string, clusterName?: string, numberOfComponents?: number) => {
    dispatch(removeMethodologyCluster(clusterId));
    handleClusterTracking(ClusterEventType.Deleted, {
      clusterNames: clusterName ? [clusterName] : [],
      numberOfClusters: 1,
      numberOfComponents: numberOfComponents ?? 0
    });
  };

  return {
    isCharacteristicClusteringEnabled,
    handleCreateCluster,
    handleEditCluster,
    handleDeleteCluster,
    isClusterModalOpen: isOpen,
    openClusterModal: onOpen,
    closeClusterModal: onClose
  };
};
